const NepaliDate = require('nepali-date');
const nd = new NepaliDate();

export default {
    filter_date: {
        from_date: '',
        to_date: nd.format('YYYY-MM-DD')
    }
};
